import { style } from "@vanilla-extract/css";

import { vars } from "~/styles/tokens.css";

// Inset panel rendered in a review task row's expansion (a full-width cell), so
// it reads as belonging to the row above it.
export const panel = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.sm,
  padding: vars.space.md,
  backgroundColor: vars.color.surfaceMuted,
  borderRadius: vars.radius.md,
});

export const header = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.sm,
});

export const title = style({
  fontWeight: vars.fontWeight.semibold,
  color: vars.color.textDefault,
  fontSize: vars.fontSize.sm,
});

export const field = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
});

export const value = style({
  fontSize: vars.fontSize.sm,
  color: vars.color.textDefault,
});

export const detail = style({
  fontSize: vars.fontSize.sm,
  color: vars.color.textMuted,
});

// Stacks verdict cards in a single task-row expansion.
export const stack = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.md,
});
